/** Ссылка на бот / канал в MAX. */
export const MAX_URL = 'https://max.ru/id5047243826_bot';

export const CONTACTS = {
  // phone: '+7 (495) 137-00-27',
  // phoneHref: '+74951370027',
  // phone: '+7 (925) 147-83-91',
  // phoneHref: '+79251478391',
  email: 'predictiveanalytics@yanao.ru',
} as const;

/** Длительность видеоинструкции, подпись в углу карточки. */
export const VIDEO_DURATION = '07:23';

export const VIDEO_URL = 'https://storage.yandexcloud.net/gosdep-backend-kd/user_guide.mp4';